import BaseModel from '../core/BaseModel'
export default class WardModel extends BaseModel {
    constructor() {
        super({ 
                name: "wards",
                tableName: 'core_ward'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}